import { render, staticRenderFns } from "./edit-list.vue?vue&type=template&id=0200db09&scoped=true&"
import script from "./edit-list.vue?vue&type=script&lang=js&"
export * from "./edit-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0200db09",
  null
  
)

export default component.exports